import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { HelperService } from '../services/helper.service';
import { StorageService } from './storage.service';
import { JWT } from '../interfaces/custom.interfaces';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class AuthenticationStorageService {

    private _jwt: JWT = null;
    private _jwt$ = new BehaviorSubject<JWT>(this._jwt);
    jwt$ = this._jwt$.asObservable();

    private _jwtStorageKey = `JWTSTORAGE-${this.helper.clientService.config.clientId}`;
    constructor(protected helper: HelperService,
        protected storageService: StorageService) {
        const jwt = this.getJWT();
        if (!!jwt) {
            this._jwt$.next(jwt);
        }
    }

    getJWT() {
        return this.storageService.getItem<JWT>(this._jwtStorageKey);
    }

    setJWT(jwt: JWT) {
        this._jwt$.next(jwt);
        this.storageService.setItem(this._jwtStorageKey, jwt);
    }

    getName() {
        const jwt = this.getJWT();
        if (!!jwt) {
            return of(`${jwt.forename} ${jwt.surname}`);
        }
        return null;
    }

    getDetails() {
        const jwt = this.getJWT();
        if (!!jwt) {
            return {
                clientId: jwt.clientId,
                userId: jwt.userId,
                userName: jwt.userName,
                forename: jwt.forename,
                surname: jwt.surname,
                expires_in: jwt.expires_in
            };
        }
        return {};
    }

    hasJWT() {
        const jwt = this.storageService.getItem<JWT>(this._jwtStorageKey);
        const hasJWT = jwt !== null ? true : false;
        if (hasJWT === false) {
            return false;
        }
        const jwtExpiration = new Date(jwt['.expires']).getTime();
        const isInDate = jwtExpiration > new Date().getTime();
        if (isInDate === false) {
            this.clearJWT();
        }
        return hasJWT === true && isInDate === true ? true : false;
    }

    clearJWT() {
        this._jwt$.next(null);
        this.storageService.clearItem(this._jwtStorageKey);
    }

    hasAllPermission(requiredPermissions: number[]) {
        if (!requiredPermissions) {
            return true;
        }

        const permissions = this.getPermissions();

        // for (let i = 0; i < requiredPermissions.length; i++) {
        //     const currentRequiredPermission = requiredPermissions[i];
        //     const foundIndex = permissions.indexOf(currentRequiredPermission);
        //     if (foundIndex <= -1) {
        //         return false;
        //     }
        // }

        for (const currentRequiredPermission of requiredPermissions) {
            const foundIndex = permissions.indexOf(currentRequiredPermission);
            if (foundIndex <= -1) {
                return false;
            }
        }
        return true;
    }

    hasAnyPermission(requiredPermissions: number[], negativePermissions?: number[]) {
        if (!requiredPermissions && !negativePermissions) {
            return true;
        }
        const permissions = this.getPermissions();
        return permissions.some(required => (!requiredPermissions || requiredPermissions.indexOf(required) !== -1))
            && permissions.every(required => (!negativePermissions || negativePermissions.indexOf(required) == -1));
    }

    getPermissions(): number[] {
        const jwt = this.getJWT();
        let roles = '';
        if (!!jwt && !!jwt['roles']) {
             roles = <string>jwt['roles'];
        }
        if (!!roles) {
            const rolesArray = roles.split(',').map(o => parseInt(o, 10));
            return rolesArray ?? [];
        }
        return [];
    }
}
